import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const ContractsPage = lazy(() => import('~/features/organization/pages/contracts-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/products')({
  beforeLoad: requirePermission('organization_contracts'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ContractsPage />
    </Suspense>
  ),
});
